/**
 * @generated SignedSource<<87cbc1f4e4d582213b6202b683d97a8b>>
 * @relayHash da2d95611136e0565049ece0971b2dae
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 03181af7331dce8124379357656310090c7af6c1fc6c48f36fff8c0fdcab4e6d

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type AsyncTeamSelectorQuery$variables = {
  containerId: string;
};
export type AsyncTeamSelectorQuery$data = {
  readonly graphStore: {
    readonly teamConnectedToContainerInverse: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly " $fragmentSpreads": FragmentRefs<"TeamCard_team" | "TeamCard_teamDEPRECATED" | "TeamItem_team">;
        } | null | undefined;
      } | null | undefined> | null | undefined;
      readonly " $fragmentSpreads": FragmentRefs<"AsyncManageTeams">;
    } | null | undefined;
  } | null | undefined;
};
export type AsyncTeamSelectorQuery = {
  response: AsyncTeamSelectorQuery$data;
  variables: AsyncTeamSelectorQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "containerId"
  }
],
v1 = [
  {
    "kind": "Literal",
    "name": "consistentRead",
    "value": true
  },
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "containerId"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v3 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "AsyncTeamSelectorQuery",
    "selections": [
      {
        "concreteType": "GraphStore",
        "kind": "LinkedField",
        "name": "graphStore",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "GraphStoreSimplifiedTeamConnectedToContainerInverseConnection",
            "kind": "LinkedField",
            "name": "teamConnectedToContainerInverse",
            "plural": false,
            "selections": [
              {
                "concreteType": "GraphStoreSimplifiedTeamConnectedToContainerInverseEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "FragmentSpread",
                            "name": "TeamCard_team"
                          },
                          {
                            "kind": "FragmentSpread",
                            "name": "TeamItem_team"
                          },
                          {
                            "kind": "FragmentSpread",
                            "name": "TeamCard_teamDEPRECATED"
                          }
                        ],
                        "type": "TeamV2"
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "FragmentSpread",
                "name": "AsyncManageTeams"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AsyncTeamSelectorQuery",
    "selections": [
      {
        "concreteType": "GraphStore",
        "kind": "LinkedField",
        "name": "graphStore",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "GraphStoreSimplifiedTeamConnectedToContainerInverseConnection",
            "kind": "LinkedField",
            "name": "teamConnectedToContainerInverse",
            "plural": false,
            "selections": [
              {
                "concreteType": "GraphStoreSimplifiedTeamConnectedToContainerInverseEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v3/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "smallHeaderImageUrl"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "smallAvatarImageUrl"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "displayName"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "description"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "isVerified"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "state"
                          },
                          {
                            "concreteType": "TeamMemberConnectionV2",
                            "kind": "LinkedField",
                            "name": "members",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TeamMemberV2",
                                "kind": "LinkedField",
                                "name": "nodes",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "name": "member",
                                    "plural": false,
                                    "selections": [
                                      (v2/*: any*/),
                                      (v3/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "name": "name"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "picture"
                                      }
                                    ]
                                  }
                                ]
                              },
                              {
                                "concreteType": "PageInfo",
                                "kind": "LinkedField",
                                "name": "pageInfo",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "hasNextPage"
                                  }
                                ]
                              }
                            ]
                          }
                        ],
                        "type": "TeamV2"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v3/*: any*/)
                        ],
                        "type": "Node",
                        "abstractKey": "__isNode"
                      }
                    ]
                  },
                  (v3/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "03181af7331dce8124379357656310090c7af6c1fc6c48f36fff8c0fdcab4e6d",
    "metadata": {},
    "name": "AsyncTeamSelectorQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "e0ec5984dbed49eb6126cf43a6c617d4";

export default node;
